import Footer from '../components/layout/Footer';
import ResearchCourseList from '../components/research/ResearchCourseList';

export default function ResearchPortal() {
  return (
    <main className="h-full flex-1 overflow-y-auto overscroll-contain">
      <div className="min-h-full flex flex-col">
        <div className="grow">
          <ResearchCourseList />
        </div>
        <Footer />
      </div>
    </main>
  );
}
